import React from "react";
import {
  Datagrid,
  DateField,
  ImageField,
  ImageInput,
  List,
  NumberInput,
  ReferenceField,
  SelectInput,
  SimpleShowLayout,
  TextField,
  ReferenceInput,
  TextInput,  required,
} from "react-admin";

import EditView from "../../../../components/EditView";
import CreateView from "../../../../components/CreateView";
import ShowView from "../../../../components/ShowView";
import { isMobile } from 'react-device-detect';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = (width) => makeStyles({ image: { width } })();

export const RawMaterialList = (props) => {
  const classes = useStyles(100);

  return (
    <List {...props} perPage={100} sort={{ field: 'order', order: 'ASC' }} >
      {isMobile ? (
        <Datagrid rowClick="show">
          <TextField source="title" />
          <ImageField source="icon" classes={classes} />
          <TextField source="price" />

        </Datagrid>
      ) : (

        <Datagrid rowClick="show">
          <TextField source="order" />
          <TextField source="title" />
          <TextField source="price" />
          <TextField source="sku" />
          <ReferenceField link={null} label="واحد" source="unit" reference="baseUnit" >
            <TextField source="title" />
          </ReferenceField>

          <ImageField source="icon" />
          {/* <TextField source="objectId"/> */}
        </Datagrid>
      )}
    </List>
  )
};

export const RawMaterialEdit = (props) => (
  <EditView {...props} perPage={10}>
    <TextInput source="title" validate={required()} />

    <NumberInput source="order" validate={required()} />
    <NumberInput source="price" />
    <ReferenceInput label="واحد" validate={required()} source="unit" reference="baseUnit">
      <SelectInput optionText="title" />
    </ReferenceInput>
    <TextInput source="sku" />

    <ImageInput source="pictures" label="تصویر مربوطه" accept="image/*">
      <ImageField source="src" title="title" />
    </ImageInput>
    <TextInput source="icon" />

  </EditView>
);

export const RawMaterialShow = (props) => (
  <ShowView {...props}>
    <SimpleShowLayout>
      <TextField source="order" />
      <ImageField source="icon" />
      <TextField source="title" />
      <TextField source="price" />
      <TextField source="sku" />
      <ReferenceField link={null} label="واحد" source="unit" reference="baseUnit" >
        <TextField source="title" />
      </ReferenceField>

      <TextField source="description" />
      <DateField locales={"fa-IR"} source="createdAt" />
      <DateField locales={"fa-IR"} source="updatedAt" />
      <TextField source="objectId" />
    </SimpleShowLayout>
  </ShowView>
);

export const RawMaterialCreate = (props) => (
  <CreateView {...props}>
    <TextInput source="title" validate={required()} />
    <NumberInput source="order" validate={required()} />
    <NumberInput source="price" validate={required()} />
    <ReferenceInput label="واحد" validate={required()} source="unit" reference="baseUnit">
      <SelectInput optionText="title" />
    </ReferenceInput>
    <TextInput source="sku" />

    <TextInput source="description" label="توضیحات" />
    <ImageInput source="pictures" label="تصویر مربوطه" accept="image/*">
      <ImageField source="src" title="title" />
    </ImageInput>
  </CreateView>
);
